import { Component, inject, OnInit } from '@angular/core';
import { AuthStore } from '@app/stores/auth.store';

@Component({
  selector: 'app-logout',
  standalone: false,
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.scss',
})
export class LogoutComponent implements OnInit {
  private readonly authStore = inject(AuthStore);

  ngOnInit(): void {
    this.authStore.logout();
  }
}
